import { trackHeapEvent } from '../../trackHeapEvent'

export enum CoreInfoHeapEvents {
  saveSingle = 'location-details-save-single-core-info',
  saveMultiple = 'location-details-save-multiple-core-info',
}

interface ActionsCoreCommonProps {
  field: string
}

interface SaveCoreCommonProps {
  status: 'Success' | 'Fail'
  primaryCategory?: string
  additionalCategories?: string
}

export interface SaveSingleCoreDataProps extends ActionsCoreCommonProps, SaveCoreCommonProps {
  storeLocationId: string
}

export interface SaveMultipleCoreDataProps extends ActionsCoreCommonProps, SaveCoreCommonProps {
  storeLocationsCount: string
  foldersCount: string
}

export interface CancelSingleCoreDataProps extends ActionsCoreCommonProps {
  storeLocationId: string
}

export interface CancelMultipleCoreDataProps extends ActionsCoreCommonProps {
  storeLocationsCount: string
  foldersCount: string
}

export const coreInfoTrackingEvents = {
  saveForSingleLocation(data: SaveSingleCoreDataProps) {
    trackHeapEvent(CoreInfoHeapEvents.saveSingle, data)
  },

  saveForMultipleLocations(data: SaveMultipleCoreDataProps) {
    trackHeapEvent(CoreInfoHeapEvents.saveMultiple, data)
  },

  cancelForSingleLocation(data: CancelSingleCoreDataProps) {
    trackHeapEvent(
      CoreInfoHeapEvents.saveSingle,
      Object.assign(
        {
          status: 'Canceled',
        },
        data,
      ),
    )
  },

  cancelForMultipleLocations(data: CancelMultipleCoreDataProps) {
    trackHeapEvent(
      CoreInfoHeapEvents.saveMultiple,
      Object.assign(
        {
          status: 'Canceled',
        },
        data,
      ),
    )
  },
}
